
  <div class="container-fluid">
    <div class="row" style="background-color: lightgray;">
      <div class="col-6">
        <p>1. Seleccione un rango de fechas</p>
        <app-rangodefechas></app-rangodefechas>
      </div>
      <div class="col-6">
        <p>2. Haga click en el botón para generar el reporte</p>
        <button *ngIf="statuslimpio" class="btn-warning  btn-block" (click)="generarReporte()">Generar reporte</button>
        <button *ngIf="! statuslimpio" class="btn-default  btn-block" (click)="nuevoReporte()">Nuevo reporte</button>
      </div>
    </div>
    <div *ngIf="alertaActiva">
      <ngb-alert #selfClosingAlert  type="warning" >
         <div class="spinner-border" role="status">
           <span class="sr-only"></span>
         </div>
         Cargando data...
       </ngb-alert>
    </div>
    <hr>
    <div class="row">
      <div class="col">
          <p>Status por cuenca:</p>
          <div *ngIf="dataChart1 != undefined">
            
            <ngx-charts-bar-horizontal-normalized
              [view]="view"
              [scheme]="colorScheme"
              [results]="dataChart1"
              [gradient]="gradient"
              [xAxis]="showXAxis"
              [yAxis]="showYAxis"
              [legend]="showLegend"
              [showXAxisLabel]="showXAxisLabel"
              [showYAxisLabel]="showYAxisLabel"
              [xAxisLabel]="xAxisLabel"
              [yAxisLabel]="yAxisLabel"
              (select)="onSelect($event)">
            </ngx-charts-bar-horizontal-normalized>
          </div>
      </div>
      <div class="col">
        <p>Total PTWs:</p>
        <div>
          <ngx-charts-pie-grid
            [view]="view"
            [scheme]="colorSchemeChart2"
            [results]="dataChart2"
            (select)="onSelect($event)">
          </ngx-charts-pie-grid>
        </div>
      </div>
    </div>
    <hr>
    <div class="row" *ngIf="dataChart1 != undefined">
      <div class="col">
        <div style="background-color: rgb(58, 113, 165); color:whitesmoke; padding:5px; border-radius:8px">
          <h4>VMM:</h4>
          <p> <small>Pendientes: {{dataChart1[0].series[0].value}}</small></p>
          <p> <small>Aprobados: {{dataChart1[0].series[1].value}}</small></p>
          <p> <small>Denegados: {{dataChart1[0].series[2].value}}</small></p>
          <p> <small>Cerrados: {{dataChart1[0].series[3].value}}</small></p>
          <p> <small>Vencidos: {{dataChart1[0].series[4].value}}</small></p>
        </div>
      </div>
      <div class="col">
        <div style="background-color: rgb(58, 113, 165); color:whitesmoke; padding:5px; border-radius:8px">
          <h4>VMM-otros:</h4>
          <p> <small>Pendientes: {{dataChart1[1].series[0].value}}</small></p>
          <p> <small>Aprobados: {{dataChart1[1].series[1].value}}</small></p>
          <p> <small>Denegados: {{dataChart1[1].series[2].value}}</small></p>
          <p> <small>Cerrados: {{dataChart1[1].series[3].value}}</small></p>
          <p> <small>Vencidos: {{dataChart1[1].series[4].value}}</small></p>
        </div>
      </div>
      <div class="col">
        <div style="background-color: rgb(58, 113, 165); color:whitesmoke; padding:5px; border-radius:8px">
          <h4>VMM - SR & TSQ</h4>
          <p> <small>Pendientes: {{dataChart1[9].series[0].value}}</small></p>
          <p> <small>Aprobados: {{dataChart1[9].series[1].value}}</small></p>
          <p> <small>Denegados: {{dataChart1[9].series[2].value}}</small></p>
          <p> <small>Cerrados: {{dataChart1[9].series[3].value}}</small></p>
          <p> <small>Vencidos: {{dataChart1[9].series[4].value}}</small></p>
        </div>
      </div>
      
      <div class="col">
        <div style="background-color: rgb(58, 113, 165);color:whitesmoke; padding:5px; border-radius:8px">
          <h4>Put.Nte:</h4>
          <p> <small>Pendientes: {{dataChart1[2].series[0].value}}</small></p>
          <p> <small>Aprobados:  {{dataChart1[2].series[1].value}}</small></p>
          <p> <small>Denegados:  {{dataChart1[2].series[2].value}}</small></p>
          <p> <small>Cerrados:   {{dataChart1[2].series[3].value}}</small></p>
          <p> <small>Vencidos:   {{dataChart1[2].series[4].value}}</small></p>
        </div>
      </div>
      <div class="col">
        <div style="background-color: rgb(58, 113, 165); color:whitesmoke; padding:5px; border-radius:8px">
          <h4>Put.Sur:</h4>
          <p> <small>Pendientes: {{dataChart1[3].series[0].value}}</small></p>
          <p> <small>Aprobados:  {{dataChart1[3].series[1].value}}</small></p>
          <p> <small>Denegados:  {{dataChart1[3].series[2].value}}</small></p>
          <p> <small>Cerrados:   {{dataChart1[3].series[3].value}}</small></p>
          <p> <small>Vencidos:   {{dataChart1[3].series[4].value}}</small></p>
        </div>
      </div>
      <div class="col">
        <div style="background-color: rgb(58, 113, 165); color:whitesmoke; padding:5px; border-radius:8px">
          <h4>Bogotá:</h4>
          <p> <small>Pendientes: {{dataChart1[4].series[0].value}}</small></p>
          <p> <small>Aprobados:  {{dataChart1[4].series[1].value}}</small></p>
          <p> <small>Denegados:  {{dataChart1[4].series[2].value}}</small></p>
          <p> <small>Cerrados:   {{dataChart1[4].series[3].value}}</small></p>
          <p> <small>Vencidos:   {{dataChart1[4].series[4].value}}</small></p>
        </div>
      </div>
      <div class="col">
        <div style="background-color: rgb(58, 113, 165); color:whitesmoke; padding:5px; border-radius:8px">
          <h4>Llanos:</h4>
          <p> <small>Pendientes: {{dataChart1[5].series[0].value}}</small></p>
          <p> <small>Aprobados:  {{dataChart1[5].series[1].value}}</small></p>
          <p> <small>Denegados:  {{dataChart1[5].series[2].value}}</small></p>
          <p> <small>Cerrados:   {{dataChart1[5].series[3].value}}</small></p>
          <p> <small>Vencidos:   {{dataChart1[5].series[4].value}}</small></p>
        </div>
      </div>
    </div>
    <hr>
    <div class="row" *ngIf="dataChart1 != undefined">
      <div class="col">
        <div style="background-color: rgb(58, 113, 165); color:whitesmoke; padding:5px; border-radius:8px">
          <h4>Charapa:</h4>
          <p> <small>Pendientes: {{dataChart1[6].series[0].value}}</small></p>
          <p> <small>Aprobados: {{dataChart1[6].series[1].value}}</small></p>
          <p> <small>Denegados: {{dataChart1[6].series[2].value}}</small></p>
          <p> <small>Cerrados: {{dataChart1[6].series[3].value}}</small></p>
          <p> <small>Vencidos: {{dataChart1[6].series[4].value}}</small></p>
        </div>
      </div>
      <div class="col">
        <div style="background-color: rgb(58, 113, 165); color:whitesmoke; padding:5px; border-radius:8px">
          <h4>Chanangue:</h4>
          <p> <small>Pendientes: {{dataChart1[7].series[0].value}}</small></p>
          <p> <small>Aprobados: {{dataChart1[7].series[1].value}}</small></p>
          <p> <small>Denegados: {{dataChart1[7].series[2].value}}</small></p>
          <p> <small>Cerrados: {{dataChart1[7].series[3].value}}</small></p>
          <p> <small>Vencidos: {{dataChart1[7].series[4].value}}</small></p>
        </div>
      </div>
      <div class="col">
        <div style="background-color: rgb(58, 113, 165);color:whitesmoke; padding:5px; border-radius:8px">
          <h4>Iguana</h4>
          <p> <small>Pendientes: {{dataChart1[8].series[0].value}}</small></p>
          <p> <small>Aprobados:  {{dataChart1[8].series[1].value}}</small></p>
          <p> <small>Denegados:  {{dataChart1[8].series[2].value}}</small></p>
          <p> <small>Cerrados:   {{dataChart1[8].series[3].value}}</small></p>
          <p> <small>Vencidos:   {{dataChart1[8].series[4].value}}</small></p>
        </div>
      </div>
    </div>  
      
      
    <hr>
    <div class="row">
      <div class="col" style="text-align: center;">
        <p><strong>Drilling:</strong></p>
        <ngx-charts-gauge
          [scheme]="colorScheme"
          [results]="dataChart3drilling"
          [legendPosition]="legendPosition"
          (select)="onSelect($event)">
        </ngx-charts-gauge>
      </div>

      <div class="col" style="text-align: center;">
        <p><strong>Producción:</strong></p>
        <ngx-charts-gauge
          [scheme]="colorScheme"
          [results]="dataChart3Produccion"
          [legendPosition]="legendPosition"
          (select)="onSelect($event)">
        </ngx-charts-gauge>
      </div>

      <div class="col" style="text-align: center;">
        <p><strong>Workover:</strong></p>
        <ngx-charts-gauge
          [scheme]="colorScheme"
          [results]="dataChart3workover"
          [legendPosition]="legendPosition"
          (select)="onSelect($event)">
        </ngx-charts-gauge>
      </div>

      <div class="col" style="text-align: center;">
        <p><strong>Sísmica:</strong></p>
        <ngx-charts-gauge
          [scheme]="colorScheme"
          [results]="dataChart3sismica"
          [legendPosition]="legendPosition"
          (select)="onSelect($event)">
        </ngx-charts-gauge>
      </div>
    </div>

    <div class="row">
      <div class="col" style="text-align: center;">
        <p><strong>Proyectos y facilidades:</strong></p>
        <ngx-charts-gauge
          [scheme]="colorScheme"
          [results]="dataChart3ProyectosYfacilidades"
          [legendPosition]="legendPosition"
          (select)="onSelect($event)">
        </ngx-charts-gauge>
      </div>

      <div class="col" style="text-align: center;">
        <p><strong>Logística:</strong></p>
        <ngx-charts-gauge
          [scheme]="colorScheme"
          [results]="dataChart3Logistica"
          [legendPosition]="legendPosition"
          (select)="onSelect($event)">
        </ngx-charts-gauge>
      </div>

      <div class="col" style="text-align: center;">
        <p><strong>Mantenimiento:</strong></p>
        <ngx-charts-gauge
          [scheme]="colorScheme"
          [results]="dataChart3mantenimiento"
          [legendPosition]="legendPosition"
          (select)="onSelect($event)">
        </ngx-charts-gauge>
      </div>

      <div class="col" style="text-align: center;">
        <p><strong>Administración:</strong></p>
        <ngx-charts-gauge
          [scheme]="colorScheme"
          [results]="dataChartadministracion"
          [legendPosition]="legendPosition"
          (select)="onSelect($event)">
        </ngx-charts-gauge>
      </div>

    </div>
    
  
      
    

  </div>
    

<hr>

<div>
     

       



</div>
